
import * as Oidc from 'oidc-client';
import { ENVIRONMENT } from 'utils/Constants';
import { checkEnv } from 'utils/config';
import { updateLocalStorage } from 'utils/CommonUtil';

export class PhoenixAuthService {
	constructor() {
		const env = checkEnv();

		const settings = {
			authority: ENVIRONMENT[env].phoenix.XPS_PING_API_ENDPOINT,
			client_id: ENVIRONMENT[env].phoenix.XPS_PING_CLIENT_ID,
			redirect_uri: window.location.origin + '/login/phx-signin-callback.html',
			post_logout_redirect_uri: window.location.origin + '/input-form',
			response_type: "code",
			scope: "openid profile",
			metadata: {
				token_endpoint: `${ENVIRONMENT[env].phoenix.XPS_PING_API_ENDPOINT}/watch/as/token.oauth2`,
				end_session_endpoint: `${ENVIRONMENT[env].phoenix.XPS_PING_API_ENDPOINT}/idp/startSLO.ping?TargetResource=${window.location.origin}`,
				authorization_endpoint: `${ENVIRONMENT[env].phoenix.XPS_PING_API_ENDPOINT}/watch/as/authorization.oauth2`,

			},
		};
		this.userManager = new Oidc.UserManager(settings);
	}

	getUser = () => {
		return this.userManager.getUser();
	};

	getLoggedInUser = () => {
		// return this.userManager.signinSilent();
		return this.userManager
			.getUser()
			.then(user => user) // updateLocalStorage('authToken', get(user, 'access_token'))
			.catch(error => console.log('user retrieval failed!!'));
	};

	login = () => {
		return this.userManager.signinRedirect();
	};

	renewToken = () => {
		// return this.userManager.signinSilent();
		return this.userManager
			.signinSilent()
			.then(user => user) // updateLocalStorage('authToken', get(user, 'access_token'))
			.catch(error => console.log('token refresh failed!!'));
	};

	logout = () => {
		return this.userManager.signoutRedirect();
	};

	signinRedirectCallback = () => {
		return this.userManager.signinRedirectCallback()
			.then(user => {
				if (user) {
					updateLocalStorage('phoenix.authToken', user.access_token);
					return user;
				} else {
					throw new Error('User not found after redirect callback');
				}
			})
			.catch(error => {
				console.error('Error during signin redirect callback:', error);
				throw error;
			});
	}
}

